import React, { useCallback } from 'react';

import { Tappable } from '@vectord/components';
import { batch, useDispatch } from 'react-redux';
import {
  setResolveSubmissionModalState,
  setSelectedSubmission,
} from 'features/neovarsityManagement';

const ReviewButton = ({ submission }) => {
  const dispatch = useDispatch();

  const handleClick = useCallback(() => {
    batch(() => {
      dispatch(setResolveSubmissionModalState(true));
      dispatch(setSelectedSubmission(submission));
    });
  }, [dispatch, submission]);

  return (
    <Tappable
      onClick={handleClick}
      className="primary bold btn-small"
    >
      Review
    </Tappable>
  );
};
export default ReviewButton;
